import { defineStore } from 'pinia'
import agreementApi from '@vue3/api/agreement-api'
import { shouldShowAgreementPopup, clearAgreementTimestampToken, setAgreementTimestampToken } from '@vue3/utils/agreement'

const agreementStore = defineStore('agreementStore', {
  state: () => ({
    isAgreementModalVisible: false,
    pendingAgreement: null,
    dealerId: '',
    agreementId: ''
  }),
  actions: {
    resetAgreementState () {
      this.isAgreementModalVisible = false
      this.pendingAgreement = null
      this.dealerId = ''
      this.agreementId = ''
    },
    openAgreementIfNeeded ({ dealerId, agreementId, success, fail } = {}) {
      this.dealerId = dealerId || ''
      this.agreementId = agreementId || ''

      if (!dealerId || !agreementId) {
        return
      }

      const shouldShow = shouldShowAgreementPopup({ dealerId, agreementId })
      if (!shouldShow) {
        return
      }

      this.fetchPendingAgreement({
        dealerId,
        success,
        fail
      })
    },
    fetchPendingAgreement ({ dealerId } = {}) {
      if (!dealerId) {
        return
      }
      agreementApi.getPendingAgreement({ dealerId })
        .then((response) => {
          const res = response?.body
          if (res && res.success) {
            this.pendingAgreement = res.value
          }

          if (res.value) {
            this.isAgreementModalVisible = true
          }
        })
        .catch(() => {
          this.pendingAgreement = null
        })
    },
    respondToAgreement ({ action, success, fail } = {}) {
      if (!this.dealerId || !this.agreementId) {
        return
      }
      agreementApi.respondToAgreement({
        id: this.agreementId,
        dealerId: this.dealerId,
        action
      }).then((res) => {
        if (action === 'AGREE') {
          clearAgreementTimestampToken({ dealerId: this.dealerId, agreementId: this.agreementId })
        } else {
          setAgreementTimestampToken({ dealerId: this.dealerId, agreementId: this.agreementId })
        }
        this.isAgreementModalVisible = false
        success && success(res)
      }).catch((err) => {
        // Even if server call fails, we still apply local UX rules.
        fail && fail(err)
      })
    }
  }
})

export default agreementStore

